import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, change } from 'redux-form';
import * as Form from '../../elements/forms/formFieldHelpers';
import { Buttons } from '../../elements/ui';

class LocationForm extends Component {
    componentDidMount () {
        this.handleInitialise();
    }

    handleInitialise = () => {
        const { initialize, profile_location } = this.props;
        const initialValues = {
                "type": !profile_location ? "CREATE" : "UPDATE",
                "country": profile_location && profile_location.hasOwnProperty('country_name') && {label: profile_location.country_name, value: profile_location.country_id},
                "region":  profile_location && profile_location.hasOwnProperty('name') && {label: profile_location.name, value: profile_location.id },
            };
         return initialize( initialValues );
     };

  componentWillReceiveProps(nextProps) {

    const {selectedCountry, resetLocation, formValues} = this.props;

    if (selectedCountry !== undefined && selectedCountry !== nextProps.selectedCountry) {

      resetLocation();
    }
  }

    normaliseData = ( formData ) => {
        const { buttonHandlers, countries, personId } = this.props;
        const selectedCountryObj = countries.find( country => country.id === formData.country.value);
        const selectedRegionName = selectedCountryObj.regions.find( region => region.id === formData.region.value).name;
        const normalisedData = {
                personId: personId,
                id: formData.region.value,
                country_id: formData.country.value,
                country_name: selectedCountryObj.name,
                name: selectedRegionName,
                type: formData.type,
            };

        return buttonHandlers.handleData( normalisedData );
    };

    render() {
        const { handleSubmit, buttonHandlers, countries, profile_location, selectedCountry } = this.props,
            numberButtons = profile_location && profile_location.hasOwnProperty('name') && 3;

      const currentCountry = (countries) && countries.filter(location => location.id ===  (selectedCountry && selectedCountry.value)  )[0];
        return (
            <form className="form-standard-profile" onSubmit={ handleSubmit ( this.normaliseData ) }>
                <Field
                    name="country"
                    label="Country"
                    placeholder="Country"
                    component={ Form.selectField }
                    clearable={true}
                    options={ countries.map( option =>  {
                        return {
                            value: option.id,
                            label: option.name
                        }
                    } ) }
                />
              <Field
                    name="region"
                    label="Region"
                    placeholder="Region"
                    component={ Form.selectField }
                    options={ currentCountry && currentCountry.regions.map(option => {
                        return {
                            value: option.id,
                            label: option.name
                        }
                    } ) }
                    clearable={true}
                />
                {/*handleSubmit is passed as undefined as in this case it is the form that is handling the onSubmit */}
                {/*and not the Save button - data needed to be normalised before submitting*/}
                <Buttons.HOCFormButtons
                    { ...this.props }
                    { ...buttonHandlers }
                    handleSubmit={ undefined }
                    numberButtons={ numberButtons }
                />
            </form>
        )
    }
}

LocationForm = reduxForm({ form: 'location' })(LocationForm);

const valueSelector = formValueSelector('location');

const mapStateToProps = ( state ) => {
    return {
        selectedCountry: valueSelector( state, 'country')
    }
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetLocation: () => dispatch(change('location', 'region', '')),
  }
};

export default connect( mapStateToProps, mapDispatchToProps ) ( LocationForm );




// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/forms/LocationForm.js